export default __webpack_public_path__ + "static/media/send_active.c82326a2.svg";